import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import toastr from 'toastr';
import Validator from '../../shared/validator';
import Loading from '../../shared/loading';
import parseFailXhr from '../../shared/parse-fail-xhr';
import { setInvestmentThemes } from '../../services/onboarding-services';

export default class OnboardingSelectInvestmentThemesModal extends React.Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    onComplete: PropTypes.func.isRequired,
    assetClasses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })).isRequired,
    currentStepIndex: PropTypes.number.isRequired,
    totalStepCount: PropTypes.number.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAssetClassesChanged = this.handleAssetClassesChanged.bind(this);

    this.state = {
      assetClassIds: [],
      userAttemptedToDismiss: false,
      validator: new Validator({
        assetClassesRequired: state => !!state.assetClassIds.length,
        userDidNotAttemptToDismiss: state => !state.userAttemptedToDismiss,
      }),
    };
  }

  componentDidMount() {
    if (this.props.active) {
      this.$modal.show();
    }

    const self = this;
    this.$modal.click(function onClick(e) {
      if (e.target === this) {
        self.setState(state => {
          state.userAttemptedToDismiss = true;
          state.validator.validateForm(state);
        });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.active && this.props.active) {
      this.$modal.fadeIn(800);
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    this.setState(
      state => {
        state.userAttemptedToDismiss = false;
        state.validator.validateForm(state);

        return state;
      },
      () => {
        if (!this.state.validator.formValid) return;

        this.loading.start();

        setInvestmentThemes(this.state.assetClassIds).then(() => {
          this.$modal.fadeOut(800, () => this.loading.stop());
          this.props.onComplete();
        }).catch(err => {
          this.loading.stop();
          const errors = parseFailXhr(err.jqXHR);
          errors.anyUnhandledErrors() && toastr.error(errors.getErrorSummary(), 'Error');
        });
      },
    );
  }

  handleAssetClassesChanged(event) {
    const assetClassId = parseInt(event.target.value, 10);
    const isSelected = event.target.checked;

    this.setState(state => {
      state.userAttemptedToDismiss = false;

      if (!isSelected) {
        _.pull(state.assetClassIds, assetClassId);
      } else {
        state.assetClassIds.push(assetClassId);
      }

      state.validator.validateAssetClassesRequired(state);

      return state;
    });
  }

  render() {
    const isInvalid = this.state.validator.userDidNotAttemptToDismissValid
      && this.state.validator.assetClassesRequiredValid;
    return (
      <div
        ref={e => (this.$modal = $(e))}
        className="livewire-modal onboarding-select-investment-themes-modal"
        tabIndex="-1"
        role="dialog"
      >
        <article>
          <header>
            {this.props.totalStepCount <= 1 || this.props.currentStepIndex === -1 || (
              <p className="step">
                {`Step ${this.props.currentStepIndex + 1} of ${this.props.totalStepCount}`}
              </p>
            )}
            <h4>Which investment themes are you most interested in?</h4>
          </header>
          <section>
            <p className="step-instructions">
              Select the asset classes and investment topics that you are interested in.
            </p>
            <form onSubmit={this.handleSubmit}>
              <Loading ref={e => (this.loading = e)} variant="small">
                <React.Fragment>
                  <div className="btn-group">
                    {this.props.assetClasses.map(assetClass => (
                      <label
                        htmlFor={`investor-type-${assetClass.id}`}
                        className="btn btn-default"
                        key={assetClass.id}
                      >
                        <input
                          id={`investor-type-${assetClass.id}`}
                          type="checkbox"
                          name="investorType"
                          autoComplete="off"
                          value={assetClass.id}
                          onChange={this.handleAssetClassesChanged}
                        />
                        {` ${assetClass.title}`}
                      </label>
                    ))}
                  </div>
                  {isInvalid || (
                    <p className="has-error">
                      <span className="help-block">Please select your investment theme interests</span>
                    </p>
                  )}
                  <p className="form-group submit-group">
                    <button type="submit" className="btn btn-primary">Continue</button>
                  </p>
                </React.Fragment>
              </Loading>
            </form>
          </section>
        </article>
      </div>
    );
  }
}
